import { persistData, getPersistedData } from '../../util/persistor';

// Import Actions
import { SET_CONVERSATIONS, REMOVE_CONVERSATION, SET_CONVERSATION_MESSAGES, SET_BOOK_GENERATION, SET_TUTORIAL, UPDATE_CONVERSATION_MESSAGE, UPDATE_CONVERSATION_MESSAGES_VISIBILITY } from './ConversationActions';
import { SET_IS_FETCHING, INIT_PERSISTED_DATA } from '../App/AppActions';
import { sortMessagesByDate } from './messagesSort';

// Initial State
export const initialState = {
    data: [],
    messages: {},
    bookGeneration: {},
    tutorials: {},
};

// Think to update reducers.js

const ConversationReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_CONVERSATIONS:
            return {
                ...state,
                data: action.isSet
                    ? action.conversations
                    : action.conversations.concat(state.data.filter(existingConversation => !action.conversations.find(newConversation => newConversation._id === existingConversation._id))),
            };

        case REMOVE_CONVERSATION:
            return {
                ...state,
                data: state.data.filter(existingConversation => action.conversationId !== existingConversation._id),
            };

        case SET_CONVERSATION_MESSAGES:
            return {
                ...state,
                messages: {
                    ...state.messages,
                    [action.conversationId]: action.messages,
                },
            };

		case UPDATE_CONVERSATION_MESSAGE: {
			const existingCollection = state.messages[action.conversationId] || [];
			const existingMessage = existingCollection.find(message => message.reference === action.message.reference);
			if(existingCollection.length) {
				const updatedCollection = existingMessage
					? existingCollection.map(message => {
						if(message.reference === action.message.reference) {
							return {
								...message,
								...action.message,
							};
						}
						return message;
					})
					: [...existingCollection, action.message];
				// Re-tri sur ajout ou changement de date/heure uniquement : le masquage en masse
				// dispatche cette action par message, un tri systématique coûterait cher sur les
				// conversations à 200 000 messages.
				const hasDateChanged = !existingMessage
					|| (action.message.date !== undefined && action.message.date !== existingMessage.date);
				return {
					...state,
					messages: {
						...state.messages,
						[action.conversationId]: hasDateChanged ? sortMessagesByDate(updatedCollection) : updatedCollection,
					},
				};
			}
			return {
				...state,
				messages: {
					...state.messages,
					[action.conversationId]: [action.message],
				},
			};
		}

		case UPDATE_CONVERSATION_MESSAGES_VISIBILITY: {
			const existingCollection = state.messages[action.conversationId] || [];
			if(!existingCollection.length || !action.references?.length) {
				return state;
			}
			// Avec snapshot : restauration après échec API (chaque message retrouve son
			// isHidden / isEdited d'origine). Sinon : application de action.isHidden.
			const snapshotByReference = action.snapshot ? new Map(action.snapshot.map(entry => [entry.reference, entry])) : null;
			const referenceSet = snapshotByReference ? null : new Set(action.references);
			return {
				...state,
				messages: {
					...state.messages,
					[action.conversationId]: existingCollection.map(message => {
						if(snapshotByReference) {
							const previous = snapshotByReference.get(message.reference);
							return previous ? { ...message, isHidden: previous.isHidden, isEdited: previous.isEdited } : message;
						}
						return referenceSet.has(message.reference)
							? { ...message, isHidden: action.isHidden, isEdited: true }
							: message;
					}),
				},
			};
		}

        case SET_BOOK_GENERATION: {
			const newBookGeneration = {
				...(state.bookGeneration || {}),
				[action.conversationId]: {
					[action.format]: {
						start: action.start,
						end: action.end,
						books: action.books.map(book => ({ pages: book.pages.map(page => ({ ...page, messages: [] })) })),
						format: action.format,
					},
				},
			};

			persistData('conversation.bookGeneration', newBookGeneration);
			return {
				...state,
				data: state.data.map(conversation => {
                    if(conversation._id === action.conversationId) {
                        return {
                            ...conversation,
                            books: action.books.map((book, index) => {
                                return {
                                    ...((conversation.books || [])[index] || {}),
                                    ...book,
                                    pages: [], // Do not save messages in DB
                                };
                            }),
                        };
                    }
                    return conversation;
                }),
				bookGeneration: newBookGeneration,
			};
        }

        case SET_TUTORIAL: {
            const newTutorials = {
                ...state.tutorials,
                [action.key]: action.value,
            };

            persistData('conversation.tutorials', newTutorials);
            return {
                ...state,
                tutorials: newTutorials,
            };
        }

        case SET_IS_FETCHING:
            if(action.dataType === 'conversations') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        case INIT_PERSISTED_DATA:
            return {
                ...initialState,
                bookGeneration: getPersistedData('conversation.bookGeneration', {}),
                tutorials: getPersistedData('conversation.tutorials', {}),
            };

        default:
            return state;
    }
};

export default ConversationReducer;
